import Vue from 'vue';
import { METHOD_TEMPLATES } from "../../utils/consts";
import { requestCgi } from "./common/requestCgi";
export const custom = async function get(params, _args, ctx) {
  const cgiName = ctx.formInfo.cgi;
  const res = await requestCgi({
    cgiName,
    params,
    instance: this
  });
  if (res.success) {
    Vue.set(this.customState, cgiName, res.body);
  }
  return res.body;
};
custom.template = [METHOD_TEMPLATES.custom];
//# sourceMappingURL=custom.js.map
